import APIService from '@/services/APIService.js';

export default {
  getValidacoes() {
    return APIService.apiCall().get('/validacaoAtributosMcpse/getValidacoes');
  },

  salvarValidacao(postData) {
    return APIService.apiCall().post(`validacaoAtributosMcpse/salvar`, JSON.stringify(postData));
  },

  excluirValidacao(id) {
    return APIService.apiCall().get(`/validacaoAtributosMcpse/excluir/${id}`);
  },

  executarValidacao(id) {
    return APIService.apiCall().get(`/validacaoAtributosMcpse/executar/${id}`);
  },

  baixarValidacao(id, config = {}) {
    return APIService.apiCall().get(`/validacaoAtributosMcpse/baixarPlanilha/${id}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000,
      ...config
    });
  }
};
